import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { PrivilegeService } from '../services/privilege/privilege.service';
import { UtilsService } from '../services/utils/utils.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  animations: [
    trigger('widthGrow', [
      state('closed', style({
        width: 0,
      })),
      state('open', style({
        width: 260
      })),
      transition('* => *', animate(150))
    ]),
  ]
})
export class SidebarComponent implements OnInit {
  @Input() from = '';
  items: MenuItem[] = [];

  constructor(
    private router: Router,
    public utils: UtilsService,
    private privilegeService: PrivilegeService,
    public authenticationService: AuthenticationService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        // console.log('event:', event)
        this.setStyleClass(event.url)
      }
    });
  }
  ngOnInit(): void {
    this.setSidebar()
    this.setStyleClass(this.router.url)
  }

  setSidebar() {
    this.items = [
      {
        label: 'Home',
        icon: 'custom-icon-home',
        routerLink: ['/home'],
        // styleClass: this.checkActiveStateForClass(['/home'])
      },
      {
        label: 'Client Communication',
        icon: 'custom-icon-client-communication',
        visible: this.getPrivilege('businessclient_notification_view'),
        routerLink: ['/client-communication'],
        // styleClass: this.checkActiveStateForClass(['/client-communication'])
      },
      {
        label: 'Client Data Management',
        icon: 'custom-icon-client-data-management',
        visible: this.getPrivilege('businessclient_datamanagement_view'),
        routerLink: ['/client-datamanagement'],
        // styleClass: this.checkActiveStateForClass(['/client-datamanagement'])
      },
      {
        label: 'Manage Users',
        icon: 'custom-icon-manage-users',
        routerLink: ['/user'],
        visible: this.getPrivilege('systemadmin_user_create') || this.getPrivilege('systemadmin_user_modify'),
        // styleClass: this.checkActiveStateForClass(['/user'])
      },
      {
        label: 'Manage Roles',
        icon: 'custom-icon-manage-role',
        routerLink: ['/role'],
        visible: this.getPrivilege('systemadmin_role_create') || this.getPrivilege('systemadmin_role_modify'),
        // styleClass: this.checkActiveStateForClass(['/role'])
      },
      {
        label: 'Manage Discount',
        icon: 'custom-icon-manage-discount',
        visible: this.getPrivilege('_ALL'),
        routerLink: ['/manage-discount'],
        // styleClass: this.checkActiveStateForClass(['/manage-discount'])
      },
      {
        label: 'Manage Subscription Plans',
        icon: 'custom-icon-manage-subscription-plan',
        visible: this.getPrivilege('_ALL'),
        routerLink: ['/manage-subscription-plan'],
        // styleClass: this.checkActiveStateForClass(['/manage-subscription-plan'])
      },
      {
        label: 'Manage Holidays',
        icon: 'custom-icon-manage-holidays',
        visible: this.getPrivilege('_ALL'),
        routerLink: ['/manage-holidays'],
        // styleClass: this.checkActiveStateForClass(['/manage-holidays'])
      },
      {
        label: 'Reports',
        icon: 'custom-icon-reports',
        visible: this.getPrivilege('businessclient_report'),
        routerLink: ['/reports'],
        // styleClass: this.checkActiveStateForClass(['/reports'])
      },
      {
        label: 'Support',
        icon: 'custom-icon-support',
        visible: this.getPrivilege('businessportal_faq_create') || this.getPrivilege('businessportal_faq_modify') || this.getPrivilege('businessportal_faq_delete') || this.getPrivilege('businessportal_faq_create') || this.getPrivilege('businessportal_faq_modify') || this.getPrivilege('businessportal_faq_delete') || this.getPrivilege('businessclient_support'),
        expanded: this.checkActiveState(['/frequently-asked-questions', '/how-to', '/support-tickets', '/terms-and-conditions']),
        // styleClass: this.checkActiveStateForClass(['/frequently-asked-questions', '/how-to', '/support-tickets']),
        items: [
          {
            label: 'Frequently Asked Questions', icon: 'custom-icon-faq', routerLink: ['/frequently-asked-questions'],
            visible: this.getPrivilege('businessportal_faq_create') || this.getPrivilege('businessportal_faq_modify') || this.getPrivilege('businessportal_faq_delete'),
            // styleClass: this.checkActiveStateForClass(['/frequently-asked-questions'])
          },
          {
            label: 'Terms and Conditions', icon: 'custom-icon-terms-of-use', routerLink: ['/terms-and-conditions'],
          },
          {
            label: 'Privacy Policy', icon: 'custom-icon-privacy-policy', routerLink: ['/privacy-policy'],
          },
          {
            label: 'How To Guide', icon: 'custom-icon-how-to-Guide', routerLink: ['/how-to'],
            visible: this.getPrivilege('businessportal_howto_create') || this.getPrivilege('businessportal_howto_modify') || this.getPrivilege('businessportal_howto_delete'),
            // styleClass: this.checkActiveStateForClass(['/how-to'])
          },
          {
            label: 'Support Tickets', icon: 'custom-icon-support-tickets', routerLink: ['/support-tickets'],
            visible: this.getPrivilege('businessclient_support'),
            // styleClass: this.checkActiveStateForClass(['/support-tickets'])
          },
        ]
      },
    ];
  }
  checkActiveState(givenLink: any[]): boolean {
    let value = false
    // console.log(this.router.url);
    for (let name of givenLink) {
      if (this.router.url.indexOf(name) === -1) {
        value = false;
      } else {
        value = true;
        break;
      }
    }
    return value;
  }

  checkActiveStateForClass(givenLink: any[]): string {
    // console.log(this.router.url);
    let value = ''
    for (let name of givenLink) {
      if (this.router.url.indexOf(name) === -1) {
        value = '';
      } else {
        value = 'menucus';
        break;
      }
    }
    return value;
  }

  setStyleClass(link: string) {
    outer: for (let parentIndex = 0; parentIndex < this.items.length; parentIndex++) {
      let element = this.items[parentIndex];
      if (element.hasOwnProperty('items') && element != undefined) {
        for (let childIndex = 0; childIndex < element.items!.length; childIndex++) {
          let data: any = element!.items![childIndex]
          if (data.routerLink[0] == link) {
            data.styleClass = 'menucus'
          } else {
            data.styleClass = ''
          }
        }
        for (let childIndex = 0; childIndex < element.items!.length; childIndex++) {
          let data: any = element!.items![childIndex]
          if (data.routerLink[0] == link) {
            element.styleClass = 'menucus'
            continue outer;
          } else {
            element.styleClass = ''
          }
        }
      } else {
        if (element.routerLink[0] == link) {
          this.items[parentIndex].styleClass = 'menucus'
        } else {
          this.items[parentIndex].styleClass = ''
        }
      }
    }
  }

  getPrivilege(id: any) {
    return this.privilegeService.getPrivileges(id);
  }

  get state(): string {
    return this.utils.state;
  }
}
